import { configureStore } from '@reduxjs/toolkit';
import dashboardReducer from '../redux/slices/dashboardSlice';
import authReducer from './slices/authSlice';
import productReducer from './slices/productSlice';
import ordersReducer from './slices/orderSlice';
export const store = configureStore({
    reducer: {
        orders: ordersReducer,
        product: productReducer,
        dashboard: dashboardReducer,
        auth: authReducer,
    }
});

export default store;